/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import FormattedRelativeWrapper from 'app/components/common/FormattedRelativeWrapper.jsx';
import AddOnChangeConfirm from 'app/components/Subscription/Confirm/AddOnChangeConfirm.jsx';
import * as _ from 'underscore';
import Loading from 'app/components/common/Loading.jsx';
import { Link } from 'react-router-dom';
import { Breakpoint } from 'react-socks';
import CurrentSubscriptionDisplay from 'app/components/Subscription/CurrentSubscriptionDisplay.jsx';
import AddOnWidget from 'app/components/Subscription/AddOnWidget.jsx';
import SubscriptionPage from '@/shadcn/components/account/SubscriptionPage/SubscriptionPage.tsx';
import { isNoOpChange, isPaymentFailure } from 'app/utility/SubscriptionErrors.js';
import { SUB_PREVIEW_ADDONS } from 'app/redux/constants.js';

class UpgradePricing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            add_on_social: 0,
            add_on_posts_1: 0,
            term: this.props.plans.current.planTerm,
            addOnError: '',
            addOnUpgrade: true,
            isEditingPlan: false,
            updatingAddOn: null,
            addOnFailure: null,
            addOnSuccess: null
        };

        this.setAddOns = this.setAddOns.bind(this);
        this.addOnUpdateSettled = this.addOnUpdateSettled.bind(this);
        this.onClickSocialAddOns = this.onClickSocialAddOns.bind(this);
        this.onClickXPosts = this.onClickXPosts.bind(this);
        this.subscriptionUpdate = this.subscriptionUpdate.bind(this);
        this.subscriptionConfirm = this.subscriptionConfirm.bind(this);
        this.addOnCancel = this.addOnCancel.bind(this);

    }

    componentDidMount() {

        this.setAddOns(this.props);

        if (dataLayer) {
            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 1, 'option': 'Upgrade'}
                    }
                }
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if ((_.isEmpty(prevProps.plans.current) && !_.isEmpty(this.props.plans.current)) &&
            this.props.plans.current.addOns &&
            this.props.plans.current.addOns != prevProps.plans.current.addOns) {
            this.setAddOns(this.props);
        }

        if (prevProps.app.loading.SUB_ADDON_UPDATE === true && this.props.app.loading.SUB_ADDON_UPDATE === false &&
            this.state.updatingAddOn) {
            this.addOnUpdateSettled();
        }

        if (!_.isEmpty(this.props.plans.current)) {
            let isEditingPlan = false,
                socialAddOns = 0,
                postAddOns = 0;

            if (this.props.plans.current.addOns.add_on_social !== undefined) {
                socialAddOns = parseInt(this.props.plans.current.addOns.add_on_social.qty, 10);
            }

            if (this.props.plans.current.addOns && this.props.plans.current.addOns.add_on_posts_1 !== undefined) {
                postAddOns = parseInt(this.props.plans.current.addOns.add_on_posts_1.qty, 10);
            }

            if (this.state.add_on_social !== socialAddOns) {
                isEditingPlan = true;
            }

            if (this.state.isEditingPlan !== isEditingPlan) {
                this.setState({
                    isEditingPlan
                });
            }

        }

    }

    setAddOns(props) {
        let addOns = 0,
            addOnPosting = 0;

        if (props.plans.current.addOns && props.plans.current.addOns.add_on_social) {
            addOns = parseInt(props.plans.current.addOns.add_on_social.qty, 10);
        }
        if (addOns !== this.state.add_on_social) {
            this.setState({
                add_on_social: addOns
            });
        }

        if (props.plans.current.addOns && props.plans.current.addOns.add_on_posts_1) {
            addOnPosting = parseInt(props.plans.current.addOns.add_on_posts_1.qty, 10);
        }
        if (addOnPosting != this.state.add_on_posts_1) {
            this.setState({
                add_on_posts_1: addOnPosting
            });
        }

    }

    // Runs before Subscription.jsx reads and clears the API error: a parent's
    // componentDidUpdate fires after its children's.
    addOnUpdateSettled() {
        let errors = this.props.getApiErrors(['SUB_ADDON_UPDATE']),
            error = errors[0]?.errors?.subscription;

        // the 3DS challenge modal resubmits this same change once the user completes it
        if (error?.TDSChallenge) {
            return;
        }

        if (errors.length && !isNoOpChange(error?.message)) {
            this.setState({
                updatingAddOn: null,
                addOnFailure: {
                    type: this.state.updatingAddOn,
                    payment: isPaymentFailure(error?.message),
                    message: error?.message
                }
            });
        } else {
            let type = this.state.updatingAddOn,
                preview = this.props.plans.changePreview;

            // What the confirm dialog showed and the user agreed to pay
            this.setState({
                updatingAddOn: null,
                addOnSuccess: {
                    type,
                    charged: preview?.type === SUB_PREVIEW_ADDONS && _.isEqual(preview.post, { [type]: this.state[type] })
                        ? preview.payload.dueToday
                        : 0
                }
            });
        }
    }

    onClickSocialAddOns(qty) {

        let nextQty = qty,
            newLimits = null,
            currentInputs = parseInt(this.props.user.perms.perms.hardLimitInputs, 10) - this.props.user.perms.resources.inputsAvailable,
            currentOutputs = parseInt(this.props.user.perms.perms.hardLimitOutputs, 10) - this.props.user.perms.resources.outputsAvailable,
            addOnUpgrade = this.state.addOnUpgrade,
            addOnError = '',
            constants = this.props.app.config.constants;

        if (nextQty < 0) {
            return;
        }

        // Going under current usage still moves the stepper, so the card can show
        // the change it's refusing; it holds the error and blocks the save.
        if ((nextQty < this.props.plans.current?.addOns?.add_on_social?.qty)) {
            addOnUpgrade = false;
            newLimits = this.props.calculateAddOns([{
                addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                quantity: nextQty
            }]);
            if ((newLimits.inputs < currentInputs) || (newLimits.outputs < currentOutputs)) {
                addOnError = "Your usage would exceed the new limits with fewer add-ons. Turn off or remove feeds and socials to fit the limits.";
            }
        }

        this.setState({
            addOnError,
            add_on_social: nextQty,
            addOnUpgrade,
            addOnFailure: null,
            addOnSuccess: null
        });

    }

    onClickXPosts(qty) {
        this.setState({
            add_on_posts_1: qty,
            addOnFailure: null,
            addOnSuccess: null
        });
    }

    subscriptionUpdate(addOnType) {
        let constants = this.props.app.config.constants,
            addOnUpdates = {},
            updatingAddOn = null;

        if (addOnType.indexOf(constants.SUBSCRIPTION_ADDON_SOCIALS) !== -1) {
            addOnUpdates.add_on_social = this.state.add_on_social;
            updatingAddOn = 'add_on_social';
        }
        if (addOnType.indexOf(constants.SUBSCRIPTION_ADDON_POSTS_1) !== -1) {
            addOnUpdates.add_on_posts_1 = this.state.add_on_posts_1;
            updatingAddOn = 'add_on_posts_1';
        }

        if (Object.keys(addOnUpdates).length) {
            this.setState({
                updatingAddOn,
                addOnFailure: null,
                addOnSuccess: null
            }, () => {
                this.props.onAddOnUpdate(addOnUpdates);
            })
        }

    }

    subscriptionConfirm(type) {

        let constants = this.props.app.config.constants,
            addOnType = [],
            confirmation = null,
            socialAddOns = 0,
            extraPosts = 0;

        if (_.isObject(this.props.plans.current.addOns.add_on_social)) {
            socialAddOns = this.props.plans.current.addOns.add_on_social.qty;
        }

        if (_.isObject(this.props.plans.current.addOns.add_on_posts_1)) {
            extraPosts = this.props.plans.current.addOns.add_on_posts_1.qty;
        }

        if (type === "add_on_social") {
            addOnType.push(constants.SUBSCRIPTION_ADDON_SOCIALS);
        }

        if (type === "add_on_posts_1") {
            addOnType.push(constants.SUBSCRIPTION_ADDON_POSTS_1);
        }

        confirmation = (
            <AddOnChangeConfirm
                {...this.props}
                addOn={type}
                quantity={this.state[type]}
                onConfirm={() => this.subscriptionUpdate(addOnType)}
                onCancel={() => {
                    this.setState({
                        add_on_posts_1: extraPosts,
                        add_on_social: socialAddOns,
                        isEditingPlan: false
                    });
                }} />
        );

        if (gtag) {
            let promoData = this.props.getPersistedData('gaPromo');

            gtag('event', 'begin_checkout', {
                currency: 'USD',
                value: 1.0,
                items: [{
                    item_id: 'dlvrit_1',
                    item_name: 'dlvr.it premium plan',
                    item_variant: (this.state.addOnUpgrade) ? 'Purchase Add-On' : 'Remove Add-On',
                    price: 1.0,
                    quantity: 1,
                    promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                    promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                }],

            });

            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: (this.state.addOnUpgrade) ? 'Purchase Add-On' : 'Remove Add-On',
                    event_data: {
                        promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                        promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                    }
                });
            }

        }

        this.props.addModal(confirmation);

    }

    addOnCancel(type) {
        let previousValue = 0;

        if (this.props.plans.current?.addOns[type]?.qty) {
            previousValue = this.props.plans.current?.addOns[type]?.qty
        }

        let state = Object.assign({}, this.state);

        state[type] = previousValue;
        state.addOnError = '';
        state.addOnFailure = null;
        state.updatingAddOn = null;

        this.setState(state);

    }

    render() {
        let constants = this.props.app.config.constants,
            currentLimits = {},
            limits = this.props.calculateAddOns([{
                addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                quantity: this.state.add_on_social
            },
            {
                addOn: constants.SUBSCRIPTION_ADDON_POSTS_1,
                quantity: this.state.add_on_posts_1
            }]),
            planLabel = '',
            planPriceLabel = '',
            today = new Date(),
            trialEnd = null,
            formattedDate = null,
            activeCoupons = [];

        if (_.isEmpty(this.props.plans.current) || _.isEmpty(this.props.plans.details[this.props.user.detail.pubLevel]) || this.props.app.loading.SUB_FETCH) {
            return (
                <Loading />
            );
        }

        currentLimits = this.props.calculateAddOns();

        if (this.props.plans.current.coupons !== undefined && this.props.plans.current.coupons.length) {
            for (let i = 0; i < this.props.plans.current.coupons.length; ++i) {
                let lineDiscount = null,
                    coupon = this.props.plans.current.coupons[i],
                    itemClass = 'active-coupon nunito-dlvr',
                    couponStart = null,
                    couponExpires = null;

                couponStart = moment(coupon.createdAt);
                if (coupon.temporalUnit !== undefined && coupon.temporalAmount !== undefined) {
                    couponExpires = couponStart.add(coupon.temporalAmount, coupon.temporalUnit).format("MMM D, YYYY");
                }

                if (coupon.type === 'fixed') {
                    lineDiscount = `$${coupon.currencies[0].amount}`;
                } else if (coupon.type === 'percent') {
                    lineDiscount = `${coupon.percent}%`;
                } else {
                    continue;
                }

                activeCoupons.push({
                    code: coupon.code,
                    discount: lineDiscount,
                    expires: couponExpires
                });
            }
        }

        planLabel = 'dlvr.it ' + this.props.plans.details[this.props.user.detail.pubLevel].label;

        planPriceLabel = <FormattedNumber value={currentLimits.price} style="currency" currency="USD"/>;


        if (this.props.errors !== null) {
            // errorBlock = (
            //     <div className="subscription-error">
            //         We couldn't complete your transaction. Please <Link to="/account/billing?update=true">update your billing information.</Link>
            //     </div>
            // );
        }



        let pendingChange = null;
        if (this.props.user.detail.postAddons > 0) {
            if (this.props.user.detail.postAddons * 100 !== parseInt(this.props.user.perms.perms.add_on_posts_1)) {
                pendingChange = ". Changes to X Posts will take effect then.";
            }
        }

        let subscriptionPause = null;
        if (this.props.user.plan.pauseStart && this.props.user.plan.pauseEnd) {
            subscriptionPause = {
                start: new Date(this.props.user.plan.pauseStart),
                end: new Date(this.props.user.plan.pauseEnd),
                cycles: this.props.user.plan.pauseCycles
            }
        } else if (this.props.user.plan.status !== undefined && this.props.user.plan.status.canceled === false) {
            // renewalBlock = (
            //     <div className="renewal-notice">
            //         (Renews {moment(this.props.plans.current.nextBilling).format("MMM D, YYYY")}{pendingChange})
            //     </div>
            // );
        }

        let postLimit = parseInt(this.props.user.perms.perms.postLimit);
        if (postLimit === 0) {
            postLimit = "Unlimited";
        }

        return (
            <div className="subscription-info">
                <div className="tw-root">
                    <SubscriptionPage
                        constants={this.props.app.config.constants}
                        plan={this.props.user.plan}
                        currentLimits={currentLimits}
                        nextLimits={limits}
                        planDetails={this.props.plans.details[this.props.user.detail.pubLevel]}
                        currentAddOns={{
                            add_on_posts_1: this.state.add_on_posts_1,
                            add_on_social: this.state.add_on_social
                        }}
                        planName={planLabel}
                        planPrice={planPriceLabel}
                        postLimit={postLimit}
                        onClickSocialAddOns={this.onClickSocialAddOns}
                        onClickXPosts={this.onClickXPosts}
                        onConfirmAddOn={this.subscriptionConfirm}
                        onCancelAddOn={this.addOnCancel}
                        cancelPlan={this.props.cancelPlan}
                        restartPlan={this.props.restartPlan}
                        activeCoupons={activeCoupons}
                        subscriptionPause={subscriptionPause}
                        comparePlans={(e) => {
                            e.preventDefault();
                            this.props.router.navigate("/account/subscription/compare")
                        }}
                        addOnError={this.state.addOnError}
                        addOnSaving={this.props.app.loading.SUB_ADDON_UPDATE ? this.state.updatingAddOn : null}
                        addOnUpdateError={this.state.addOnFailure}
                        addOnSuccess={this.state.addOnSuccess}
                        updatePaymentMethod={() => {
                            this.props.router.navigate("/account/billing?update=true");
                        }}
                        setRequestParams={this.props.setRequestParams}
                        promoClick={this.props.promoClick}
                        changeTerm={this.props.changeTerm}
                        resumeSubscription={() => {
                            this.props.pauseSubscription({
                                duration: 0
                            });
                        }}
                    />
                </div>
            </div>
        );
    }

};

UpgradePricing.displayName = "UpgradePricing";

UpgradePricing.propTypes = {
    userPerms: PropTypes.object,
    currentSubscription: PropTypes.object,
    planDetails: PropTypes.object,
    onAddOnUpdate: PropTypes.func,
    subscriptionUpdate: PropTypes.func,
    errors: PropTypes.object
};

UpgradePricing.defaultProps = {
    userPerms: {},
    currentSubscription: {},
    planDetails: {},
    onAddOnUpdate: null,
    subscriptionUpdate: null,
    errors: null
};

export default UpgradePricing;
